import { parseSizeList } from './parseSizeList';

export interface PdpSizeSectionVisibilityInput {
  productSize: string | null;
  isSizeableProduct: boolean;
  sizeListLength: number;
  readyToShipQuantity: number | null;
}

function hasProductSize(productSize: string | null): boolean {
  return Boolean(productSize && productSize !== '00');
}

export function shouldShowPdpSizeDropdown({
  productSize,
  isSizeableProduct,
  sizeListLength,
}: PdpSizeSectionVisibilityInput): boolean {
  return sizeListLength > 0 || isSizeableProduct || hasProductSize(productSize);
}

export function shouldShowPdpFreeSize({
  productSize,
  isSizeableProduct,
  sizeListLength,
  readyToShipQuantity,
}: PdpSizeSectionVisibilityInput): boolean {
  return (
    readyToShipQuantity != null &&
    readyToShipQuantity > 0 &&
    !shouldShowPdpSizeDropdown({ productSize, isSizeableProduct, sizeListLength, readyToShipQuantity })
  );
}

export function shouldShowPdpSizeSection(input: PdpSizeSectionVisibilityInput): boolean {
  return shouldShowPdpSizeDropdown(input) || shouldShowPdpFreeSize(input);
}

export function deriveIsSizeableProduct(
  productSize: string | null,
  isSizeableProduct: boolean,
  customizationOptions: unknown
): boolean {
  if (isSizeableProduct) return true;
  if (parseSizeList(customizationOptions).length > 0) return true;
  return hasProductSize(productSize);
}
